import type { IFileState, IPixabayImage } from "@/interfaces";

const toFileState = (images: IPixabayImage[]): IFileState[] => {
  return images.map((image) => {
    return {
      id: image.id.toString(),
      name: image.id?.toString(),
      url: image.largeImageURL,
      size: image.imageSize,
      source: "pixabay",
      type: "image",
    };
  });
};

export default {
  toFileState,
};
